import { ChainId } from '@neonswap/testnet-sdk'

const chainId = process.env.REACT_APP_CHAIN_ID
export const explorerLink = parseInt(chainId, 10) === ChainId.MAINNET ? 'https://devnet.neonevm.org/address/' : ''
